module.exports = __webpack_public_path__ + "45f0d98d71fbd337fecb80ad292b4891.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/script/svganimations/svg/DESIGN_SVG.svg
 ** module id = 18
 ** module chunks = 0
 **/